import { isValid } from 'date-fns/isValid'
// eslint-disable-next-line no-restricted-imports -- this check grants the brand that parseDateFromISO requires
import { parseISO } from 'date-fns/parseISO'

const ZONED_INSTANT = /T\d{2}:?\d{2}(:?\d{2}([.,]\d+)?)?(Z|[+-](?:[01]\d|2[0-3])(:?\d{2})?)$/i

export const isISODateTime = (value: Maybe<string>): value is ISODateTime =>
  typeof value === 'string' && ZONED_INSTANT.test(value) && isValid(parseISO(value))
